/* eslint-disable no-undef */
import Vue from 'vue'
import Cookies from 'js-cookie'
import 'bower/devbridge-autocomplete/dist/jquery.autocomplete'

const document = window.document

export default {
  computed: {
    arrivaXcEndpoint: function () {
      return Vue.prototype.$container.config.arrivaXcEndpoint
    },
    fontSizeIncreasedCookieName: function () {
      return Vue.prototype.$container.config.arrivaXcCookieNameFontSizeIncreased
    },
    currentRegionCookieName: function () {
      return Vue.prototype.$container.config.arrivaXcCookieNameCurrentRegion
    },
    currentRegionIdCookieName: function () {
      return Vue.prototype.$container.config.arrivaXcCookieNameCurrentRegionId
    },
    arrivaXcCookieDomain: function () {
      return Vue.prototype.$container.config.arrivaXcCookieDomain
    }
  },
  methods: {
    activateSearch: function () {
      this.$el.querySelector('li.search').classList.add('active')
      this.$el.querySelector('li.search a').setAttribute('aria-hidden', true)
      this.$el.querySelector('.searchbox-results').classList.add('active')
      this.$el.querySelector('.searchbox-results').setAttribute('aria-expanded', true)
      this.$el.querySelector('.searchbox').setAttribute('aria-hidden', false)
      this.$el.querySelector('.searchbox input:nth-child(1)').focus()
      this.$el.addEventListener('keyup', (event) => { if (event.keyCode === 27) this.closeSearch() })
    },
    closeSearch: function () {
      this.$el.querySelector('li.search').classList.remove('active')
      this.$el.querySelector('li.search a').setAttribute('aria-hidden', false)
      this.$el.querySelector('.searchbox-results').classList.remove('active')
      this.$el.querySelector('.searchbox-results').setAttribute('aria-expanded', false)
      this.$el.querySelector('.searchbox').setAttribute('aria-hidden', true)
      this.$el.removeEventListener('keyup', (event) => { if (event.keyCode === 27) this.closeSearch() })
    },
    autoCompleteSearch: function () {
      jQuery(document.getElementById('searchbox-autocomplete')).devbridgeAutocomplete({
        paramName: 'query',
        serviceUrl: `${this.arrivaXcEndpoint}/zoekresultaat.htm`,
        minChars: 3,
        delay: 0,
        appendTo: document.querySelector('.searchbox-results'),
        noCache: false,
        preventBadQueries: false,
        deferRequestBy: 500,
        autoSelectFirst: false,
        transformResult: function (response) {
          if (response !== '') {
            response = JSON.parse(response)
            return {
              suggestions: response.map(suggestion => ({
                value: suggestion.value,
                data: suggestion.key
              }))
            }
          }
        },
        beforeRender: function (container, suggestions) {
          const searchBox = document.querySelector('div.searchbox-results')
          const ul = document.createElement('ul')

          suggestions.forEach(function (suggestion, i) {
            if (i < 4) {
              const li = document.createElement('li')
              const a = document.createElement('a')
              a.setAttribute('href', suggestion.data)
              a.insertAdjacentHTML(
                'afterbegin',
                suggestion.value
                  .replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
              )
              li.appendChild(a)
              ul.appendChild(li)
            }
          })
          if (suggestions.length > 0) {
            searchBox.innerHTML = ''
            searchBox.appendChild(ul)
          }
        }
      })
    },
    initiateFontToggler: function () {
      if (Cookies.get(this.fontSizeIncreasedCookieName) === 'true') {
        this.setLargeFontEnabled(true)
      }

      const enlargeFontButton = this.$el.querySelector('li.enlarge-font')
      enlargeFontButton.addEventListener('click', () => this.toggleLargeFont())
    },
    toggleLargeFont: function () {
      const body = document.getElementsByTagName('body').item(0)
      this.setLargeFontEnabled(!body.classList.contains('large-font'))
    },
    setLargeFontEnabled: function (enabled) {
      const body = document.getElementsByTagName('body').item(0)
      const attributes = { domain: this.arrivaXcCookieDomain }
      if (enabled) {
        body.classList.add('large-font')
        Cookies.set(this.fontSizeIncreasedCookieName, 'true', attributes)
      } else {
        body.classList.remove('large-font')
        Cookies.remove(this.fontSizeIncreasedCookieName, attributes)
      }
    },
    newsletterListener: function () {
      const newsletterButton = this.$el.querySelector('.footer-meta .newsletter form a.button.postfix')
      newsletterButton.addEventListener('click', e => {
        e.preventDefault()
        newsletterButton.closest('form').submit()
      })
    },
    regionSelectListener: function () {
      const regionLinks = this.$el.querySelectorAll('#regionSelector li a')

      Array.from(regionLinks).forEach(regionLink => {
        regionLink.addEventListener('click', e => {
          e.preventDefault()
          Cookies.set(this.currentRegionIdCookieName, regionLink.getAttribute('data-regio'), { domain: this.arrivaXcCookieDomain })
          Cookies.set(this.currentRegionCookieName, regionLink.getAttribute('data-regioname'), { domain: this.arrivaXcCookieDomain })
          window.location.reload(true)
        })
      })
    },
    mobileMenu: function () {
      this.$el.querySelector('.right-off-canvas-menu').setAttribute('style', `height: ${window.innerHeight}px`)
      const open = this.$el.querySelector('a.right-off-canvas-toggle')
      const close = this.$el.querySelector('a.exit-off-canvas')
      const subMenuLinks = this.$el.querySelectorAll('.off-canvas-submenu-call')

      Array.from(subMenuLinks).forEach(subMenuLink => {
        this.toggleDisplay(subMenuLink.nextElementSibling)

        subMenuLink.addEventListener('click', e => {
          e.preventDefault()
          this.toggleDisplay(subMenuLink.nextElementSibling)
        })
      })

      open.addEventListener('click', e => {
        e.preventDefault()
        document.querySelector('.off-canvas-wrap').classList.add('offcanvas-overlap')
      })

      close.addEventListener('click', e => {
        e.preventDefault()
        document.querySelector('.off-canvas-wrap').classList.remove('offcanvas-overlap')
      })
    },
    toggleDisplay: function (element) {
      element.style.display = window.getComputedStyle(element).display === 'block' ? 'none' : 'block'
    },
    updateUserElements: function (user) {
      const $navItem = this.$el.querySelector('nav.meta li.login span')
      const $menuItem = this.$el.querySelector('.main-menu .my-arriva-link')

      const displayName = user && user.profile ? getUserDisplayName(user) : this.$t('generic.my-arriva-label')

      if ($navItem) $navItem.textContent = displayName
      if ($menuItem) {
        const $icon = document.createElement('i')
        $icon.className = 'icon-user'

        $menuItem.innerHTML = ''
        $menuItem.appendChild($icon)
        $menuItem.appendChild(document.createTextNode(displayName))
      }
    },
    initiateSkipToContentLink: function () {
      const $skipToContentLink = this.$el.querySelector('.skip-to-content')
      const $skipToContentLinkWrapper = this.$el.querySelector('.skip-to-content-wrapper')

      jQuery($skipToContentLink).focus(function () {
        jQuery($skipToContentLinkWrapper).css({
          'position': 'relative',
          'top': '0',
          'left': '0',
          'width': '100%',
          'height': 'auto',
          'overflow': 'visible'
        })
      })
      jQuery($skipToContentLink).focusout(function () {
        jQuery($skipToContentLinkWrapper).css({
          'position': 'absolute',
          'top': '-1000px',
          'left': '-1000px',
          'width': '0',
          'height': '0',
          'overflow': 'hidden'
        })
      })
      jQuery($skipToContentLink).click(function (event) {
        const skipTo = '#' + this.href.split('#')[1]
        jQuery(skipTo).attr('tabindex', -1).on('blur', function (e) {
          e.preventDefault()
          jQuery(this).removeAttr('tabindex')
        })
        jQuery($skipToContentLinkWrapper).css({
          'position': 'absolute',
          'top': '-1000px',
          'left': '-1000px',
          'width': '0',
          'height': '0',
          'overflow': 'hidden'
        })
      })
    }
  }
}

const getUserDisplayName = user => {
  if (!(user && user.profile)) {
    return ''
  }

  const parts = []
  parts.push(user.profile.firstName)
  if (user.profile.surnamePrefix) parts.push(user.profile.surnamePrefix)
  parts.push(user.profile.surname)

  return parts.join(' ')
}



// WEBPACK FOOTER //
// ./src/mixins/xc-helper.js